module.exports = __webpack_public_path__ + "img/bandeau.14b05ffa.jpg";